import { cx } from "@suse-o11y/class-variance";
import React from "react";

import { CollapsibleContent } from "~/components/collapsible/content";

import { Wrap } from "../conditional-wrapper/Wrap";

import styles from "./widget.module.css";
import { useIsWidgetExpandable } from "./widget-context";

export interface WidgetBodyProps {
	/**
	 * Whether to render the body as a card.
	 *
	 * @default false
	 */
	card?: boolean;

	className?: string;

	children: React.ReactNode;
}

export const WidgetBody = React.forwardRef<HTMLDivElement, WidgetBodyProps & React.HTMLAttributes<HTMLDivElement>>(
	({ card = false, className, ...props }, ref) => {
		const expandable = useIsWidgetExpandable();

		return (
			<Wrap
				if={expandable}
				// explicitly do not make as child so it wraps the inner div around CollapsibleContent and animates nicely
				with={<CollapsibleContent asChild={false} />}
			>
				<div className={cx(className, styles.body, card && styles.bodyCard)} ref={ref} {...props} />
			</Wrap>
		);
	},
);
